export default "__VITE_ASSET__Be10EYc6__";